import { parseEntityRef } from '@backstage/catalog-model';

function getEntityRelations(entity, relationType, filter) {
  var _a;
  let entityNames = ((_a = entity == null ? void 0 : entity.relations) == null ? void 0 : _a.filter((r) => r.type === relationType).map((r) => parseEntityRef(r.targetRef))) || [];
  if (filter == null ? void 0 : filter.kind) {
    entityNames = entityNames.filter(
      (e) => e.kind.toLocaleLowerCase("en-US") === filter.kind.toLocaleLowerCase("en-US")
    );
  }
  return entityNames;
}

export { getEntityRelations };
//# sourceMappingURL=getEntityRelations.esm.js.map
